import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { AuthProvider, queryClient, initAppCheck } from '@weebee/api';
import { routeTree } from './routeTree.gen';
import './styles/globals.css';

// Prod/preprod enforce Firebase App Check on signInWithCustomToken; without an
// initialized provider the phone-OTP sign-in is rejected with 401. Mirrors tickets.
initAppCheck();

const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
